export const postData = function (res) {
  let data = new URLSearchParams()
  Object.keys(res).forEach((key) => {
    const value = res[key]
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          data.append(key, v)
        })
      } else {
        data.append(key, value)
      }
    }
  })
  return data
}

export default {
  install(Vue) {
    Vue.prototype.postData = postData
  }
}
